import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MenuService } from '@core/menu/menu.service';
import { ApplicationStore } from '@core/store/application.store';
import { AuthService } from '@features/auth/auth.service';
import { AuthStore } from '@features/auth/store/auth.store';
import { TranslocoModule } from '@jsverse/transloco';
import { SidebarItemComponent } from './sidebar-item.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  selector: 'fc-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  providers: [MenuService],
  imports: [RouterModule, SidebarItemComponent, TranslocoModule, MatIconModule],
})
export class SidebarComponent {
  private readonly authStore = inject(AuthStore);
  private readonly authService = inject(AuthService);
  private readonly menuService = inject(MenuService);
  private readonly applicationStore = inject(ApplicationStore);

  readonly isAuthenticated: Signal<boolean> = computed(() => this.authStore.token() !== null);

  readonly menuMain = this.menuService.getMainMenu();

  logout(): void {
    this.menuService.closeMenu();
    this.authService.signOut().subscribe();
  }
}
